import { render, staticRenderFns } from "./_Button.vue?vue&type=template&id=471487be"
import script from "./_Button.vue?vue&type=script&lang=js"
export * from "./_Button.vue?vue&type=script&lang=js"
import style0 from "./_Button.vue?vue&type=style&index=0&id=471487be&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports